import { flatten as i } from "./flatten.js";
import { warn as l } from "../naive/warn.js";
function d(o, t = "default", n = void 0) {
  const e = o[t];
  if (!e)
    return l("getFirstSlotVNode", `slot[${t}] is empty`), null;
  const r = i(e(n));
  return r.length === 1 ? r[0] : (l("getFirstSlotVNode", `slot[${t}] should have exactly one child`), null);
}
function f(o, t, n) {
  if (!t)
    return null;
  const e = i(t(n));
  return e.length === 1 ? e[0] : (l("getFirstSlotVNode", `slot[${o}] should have exactly one child`), null);
}
export {
  d as getFirstSlotVNode,
  f as getFirstSlotVNodeWithTypedProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/get-first-slot-vnode.js
// module id = 476
// module chunks = 67